// extracted by mini-css-extract-plugin
export default {"l":"Caption_l__pORfx","m":"Caption_m__ssCT0","s":"Caption_s__an6U6","xs":"Caption_xs__eekuD"};